// import React, { Suspense } from "react";
// import Sidebar from "./Sidebar";
// import Footer from "./Footer";
// import Topbar from "./Topbar";
// import RolePosTopBar from "./RolePosTobar"; // Adjust the import path as needed
// import { Route, Routes } from "react-router-dom";
// import routes from "../utils/routes";
// // import Home from "../../views/shops/ShopDisplayList";
// // import NotFound from "../../views/shops/ShopDisplayList";
// import { useAuthContext } from "../../components/AuthProvider"; // Adjust the import path as needed

// function DefaultLayout() {
//   const { loginRole } = useAuthContext(); // Access loginRole from AuthContext
//   const isPosOperator = loginRole.includes("POS Operator"); // Check for POS Operator role

//   return (
//     <>
//       {!isPosOperator && <Sidebar />} {/* Conditionally render Sidebar */}
//       <main className="main-content">
//         <div className="position-relative iq-banner">
//           {isPosOperator ? <RolePosTopBar /> : <Topbar />} {/* Conditionally render top bar */}
//           <div className="conatiner-fluid content-inner mt-n5 py-0">
//             <div className="row">
//               <Suspense fallback={<div>Loading...</div>}>
//                 <Routes>
//                   {routes.map((route, idx) => (
//                     <Route key={idx} path={route.path} element={<route.component />} />
//                   ))}
//                   {/* <Route path="/" element={<Home />} />
//                   <Route path="*" element={<NotFound />} /> */}
//                 </Routes>
//               </Suspense>
//             </div>
//           </div>
//         </div>
//       </main>
//       <Footer />
//     </>
//   );
// }

// export default DefaultLayout;

import React, { Suspense } from "react";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import Topbar from "./Topbar";
import RolePosTopBar from "./RolePosTobar";
import { Route, Routes } from "react-router-dom";
import routes from "../utils/routes";
import { useAuthContext } from "../../components/AuthProvider";

function DefaultLayout() {
  const { selectedRole, loginRole } = useAuthContext();

  // Determine if we are in POS mode:
  // - selectedRole is 'POS Operator' OR
  // - no selectedRole but POS Operator exists in roles (fallback for old sessions)
  const isPosMode = selectedRole === "POS Operator" || 
                   (!selectedRole && loginRole.includes("POS Operator"));

  return (
    <>
      {!isPosMode && <Sidebar />}
      <main className="main-content">
        <div className="position-relative iq-banner">
          {isPosMode ? <RolePosTopBar /> : <Topbar />}
          <div className="conatiner-fluid content-inner mt-n5 py-0">
            <div className="row">
              <Suspense fallback={<div>Loading...</div>}>
                <Routes>
                  {routes.map((route, idx) => (
                    <Route key={idx} path={route.path} element={<route.component />} />
                  ))}
                </Routes>
              </Suspense>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}

export default DefaultLayout;